import { render, staticRenderFns } from "./HelpTasks.vue?vue&type=template&id=226baff6&"
import script from "./HelpTasks.vue?vue&type=script&lang=js&"
export * from "./HelpTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports